module.exports = __webpack_public_path__ + "static/img/5.fa632be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/zh/5.png
// module id = PAm6
// module chunks = 0